// extracted by mini-css-extract-plugin
export default {"errors":"Eyg3xpvwoj2OVxYpKFZG__errors___"};